import { __assign, __rest } from "tslib";
/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Form.Subcomponent` filename
import React from 'react';
import PropTypes from 'prop-types';
import formValidationRulesPropType from '../propTypes/formValidationRulesPropType';
import RichTextField from './RichTextField';
import useFormInput from '../hooks/useFormInput';
var FormRichTextField = function (_a) {
    var _b;
    var initialValue = _a.initialValue, label = _a.label, name = _a.name, rules = _a.rules, props = __rest(_a, ["initialValue", "label", "name", "rules"]);
    /**
     * The RichTextField component renders an empty <p> tag when the user
     * has deleted the value which doesn't trip the required validation
     * rule.  Instead, when required is provided, we switch it out for the
     * validate function instead
     */
    var richTextFieldRules = rules;
    if (rules === null || rules === void 0 ? void 0 : rules.required) {
        var _maxLength = rules.maxLength, _minLength = rules.minLength, required = rules.required, validate_1 = rules.validate, otherRules = __rest(rules, ["maxLength", "minLength", "required", "validate"]);
        richTextFieldRules = __assign({ required: required, validate: function (value) {
                var _a, _b;
                var markup = new DOMParser().parseFromString(value, 'text/html');
                var textValue = (_b = (_a = markup.querySelector('body')) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : '';
                if ((rules === null || rules === void 0 ? void 0 : rules.required) && textValue === '') {
                    // The RichTextField is empty and therefore invalid
                    return (rules === null || rules === void 0 ? void 0 : rules.required).message;
                }
                else if ((rules === null || rules === void 0 ? void 0 : rules.maxLength) &&
                    (textValue === null || textValue === void 0 ? void 0 : textValue.length) > rules.maxLength.value) {
                    // The RichTextField has too much text
                    return (rules === null || rules === void 0 ? void 0 : rules.maxLength).message;
                }
                else if ((rules === null || rules === void 0 ? void 0 : rules.maxLength) &&
                    (textValue === null || textValue === void 0 ? void 0 : textValue.length) < rules.minLength.value) {
                    // The RichTextField has too little text
                    return (rules === null || rules === void 0 ? void 0 : rules.minLength).message;
                }
                return validate_1 === null || validate_1 === void 0 ? void 0 : validate_1(value);
            } }, otherRules);
    }
    var _c = useFormInput({
        name: name,
        initialValue: initialValue,
        label: label,
        rules: richTextFieldRules
    }), dataLastManuallyCleared = _c.dataLastManuallyCleared, errorMessage = _c.errorMessage, formattedLabel = _c.formattedLabel, onBlur = _c.onBlur, onChange = _c.onChange, value = _c.value;
    return (React.createElement(RichTextField, __assign({}, props, { editorContentLastSynched: (_b = props.editorContentLastSynched) !== null && _b !== void 0 ? _b : dataLastManuallyCleared, errorMessage: errorMessage, label: formattedLabel, onBlur: onBlur, onChange: onChange, value: value })));
};
FormRichTextField.propTypes = {
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
    name: PropTypes.string.isRequired,
    rules: formValidationRulesPropType
};
export default FormRichTextField;
//# sourceMappingURL=Form.RichTextField.js.map